module.exports = __webpack_public_path__ + "img/icon-male.87caaf45.svg";